import * as React from 'react';
import { Button } from 'antd';
import { inquiryModes } from 'src/components/pages/Enquiry/InquiryUtils';

const InquiryModes = (props) => {
  const { appliedFilters : { modeList }, disableDomestic,modules } = props;
  const modes = modules?.show_road_instead_of_domestic
  ? inquiryModes.filter(item => item.label !== 'Domestic')
  : inquiryModes.filter(item => item.label !== 'Road');
  return (<div style={{ display: 'flex', marginLeft: '20px', marginTop: '-6px' }}>
    <span style={{ lineHeight: '30px', marginRight: '5px' }}>Mode:</span>
    {modes.map((mode) => {
      if (mode.value === 'DOMESTIC' && disableDomestic) {
        return ''
      }
      const index = modeList.indexOf(mode.value);
      const modeButtonStyle = {
        margin: '0px 5px',
        ...(index > -1 && {
          color: '#1875F0',
          border: '1px solid #1875F0',
        }),
      };
      return (<Button style={modeButtonStyle} key={mode.value}
        onClick={() => {
          if (index > -1) {
            modeList.splice(index, 1);
          } else {
            modeList.push(mode.value);
          }
          props.setFilter(modeList);
        }}>
        {mode.label}</Button>);
    })}
    </div>);
};

export default InquiryModes;
